export enum STATUS_VISA {
  DRAFT = "DRAFT", //ร่าง
  WAITING_RECEIVE_REQUEST = "WAITING_RECEIVE_REQUEST", //รอรับคำร้อง
  RECEIVE_REQUEST = "RECEIVE_REQUEST", //รับคำร้อง
  ACCEPTING_REQUEST = "ACCEPTING_REQUEST", //รับคำร้อง
  REJECT_REQUEST = "REJECT_REQUEST", //ปฏิเสธคำร้อง
  REVIEW = "REVIEW", //ส่งทบทวน
  WAITING_PAYMENT = "WAITING_PAYMENT", //รอชำระเงิน
  WAITING_PAYMENT_VERIFICATION = "WAITING_PAYMENT_VERIFICATION", //รอตรวจสอบการชำระเงิน
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED", //ชำระเงินแล้ว
  COMPLETE = "COMPLETE", //เสร็จสิ้น
}
export const status_visa: {
  label: string;
  value: string;
}[] = [
  {
    label: "ร่าง",
    value: STATUS_VISA.DRAFT,
  },
  {
    label: "รอรับคำร้อง",
    value: STATUS_VISA.WAITING_RECEIVE_REQUEST,
  },
  {
    label: "รับคำร้อง",
    value: STATUS_VISA.RECEIVE_REQUEST,
  },
  {
    label: "รับคำร้อง",
    value: STATUS_VISA.ACCEPTING_REQUEST,
  },
  {
    label: "ปฏิเสธคำร้อง",
    value: STATUS_VISA.REJECT_REQUEST,
  },
  {
    label: "ส่งทบทวน",
    value: STATUS_VISA.REVIEW,
  },
  {
    label: "เสร็จสิ้น",
    value: STATUS_VISA.COMPLETE,
  },
  {
    label: "รอชำระเงิน",
    value: STATUS_VISA.WAITING_PAYMENT,
  },
  {
    label: "รอตรวจสอบการชำระเงิน",
    value: STATUS_VISA.WAITING_PAYMENT_VERIFICATION,
  },
 

]
export const renderStatus = (value: string): string => {
  return (
    status_visa.find((x) => x.value === value)?.label ||
    status_visa.find((x) => x.value.split(",").includes(value))
      ?.label ||
    ""
  );
};


